import { createContext, useContext, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import queryString from "query-string";

import api from "libs/api";
import website_status_data from "libs/website_status_data.json";

const UsersContext = createContext();

const UsersProvider = ({ children }) => {
  const { search } = useLocation();
  const navigate = useNavigate();

  const filters = queryString.parse(search);
  const default_sort = "created_at:desc";

  const [init_loading, setInitLoading] = useState(true);

  const { isLoading: loading, data: users } = useQuery(
    ["users", filters],
    () =>
      api.get(
        `/admin/users?${queryString.stringify({
          ...filters,
          type:
            website_status_data?.find((item) => item?.key === filters?.type)
              ?.value || undefined,
          sort: filters?.sort || default_sort,
        })}`
      ),
    {
      onSuccess: () => {
        setInitLoading(false);
      },
    }
  );

  const filterHandler = (name, value) => {
    navigate(
      `/users?${queryString.stringify({
        ...filters,
        [name]: value || undefined,
      })}`
    );
  };

  const value = useMemo(() => {
    return {
      data: users,
      loading,
      init_loading,
      filters,
      filterHandler,
    };
    // eslint-disable-next-line
  }, [users, loading, init_loading, filters]);

  return (
    <UsersContext.Provider value={value}>{children}</UsersContext.Provider>
  );
};

const useUsers = () => useContext(UsersContext);
export { UsersContext, useUsers };
export default UsersProvider;
